// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { Moves } from '@gql/base-types';

import { getFormattedCombinedStatusFromMove } from '@services/statusService';

import { Chip } from '@mui/material';
import { BiPlayCircle, BiSolidCheckCircle, BiSolidPencil, BiSolidTime, BiSolidXCircle } from 'react-icons/bi';

import ConfirmationStatusTooltip from './ConfirmationStatusTooltip';

// TYPES ---------------------------------------------------------------------- //

interface MoveStatusBadgeProps {
  move?: Moves;
}

// COMPONENT ------------------------------------------------------------------ //

const MoveStatusBadge = ({ move }: MoveStatusBadgeProps) => {
  if (!move) return null;

  const getStatusColor = (move: Moves) => {
    const { cancel_status, status } = move;

    if (cancel_status) return `error`;
    if (!status) return `default`;
    if (status === `dispatched`) return `info`;
    if (status === `delivery successful`) return `success`;
    return `warning`;
  };

  const getStatusIcon = (move: Moves) => {
    const { cancel_status, status } = move;

    if (cancel_status) return <BiSolidXCircle />;
    if (!status) return <BiSolidTime />;
    if (status === `dispatched`) return <BiSolidPencil />;
    if (status === `delivery successful`) return <BiSolidCheckCircle />;
    return <BiPlayCircle />;
  };

  const badge = (
    <Chip
      color={getStatusColor(move)}
      label={getFormattedCombinedStatusFromMove(move)}
      icon={getStatusIcon(move)}
      sx={{ fontWeight: 'bold' }}
    />
  );

  // Wrap with confirmation tooltip if move is unconfirmed
  return <ConfirmationStatusTooltip move={move}>{badge}</ConfirmationStatusTooltip>;
};

export default MoveStatusBadge;
